export default __webpack_public_path__ + "static/media/pchome.163490e8.xlsx";